module.exports = __webpack_public_path__ + "static/img/ar.63c97421.png";